import React, { useState } from 'react';
import { Button } from 'reactstrap';
import AddNewProduct from './AddNewProduct';

export default function ProductFormButton({
    id,
    LoadData,
    categoryList,
    createdBy
}) {
    const [isUpdating, setIsUpdating] = useState(false);

    return (
        <div>
            <Button
                color="primary"
                size="sm"
                onClick={() => setIsUpdating(!isUpdating)}
            >
                {createdBy && (createdBy === 'Farehourbor' || createdBy === 'Rezdy' || createdBy === 'Ways') ? 'View' : 'Edit'}
            </Button>
            {isUpdating && (
                <AddNewProduct
                    id={id}
                    toggleModal={() => {
                        setIsUpdating(!isUpdating);
                    }}
                    formLabel="Edit Product"
                    visible={isUpdating}
                    LoadData={LoadData}
                    categoryList={categoryList}
                />
            )}
        </div>
    );
}

